import type React from 'react';

import type { StreamId } from '@vlabs/api/artemy/model';
import { confirmDeleteStreams } from '@vlabs/monokit/features/delete-stream';
import { usePageContext } from '@vlabs/monokit/shared/ui/page';
import { withPermissions } from '@vlabs/permissions';
import { Control } from '@vlabs/uikit';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button';

import { useSourceStreamPageTranslation } from './i18n';
import { useDeleteSourceStream } from './useDeleteSourceStream';

interface DeleteSourceStreamButtonProps extends ButtonProps {
  streamId: StreamId;
  onDeleted?: VoidFunction;
}

function DeleteSourceStreamButton({
  streamId,
  onDeleted = undefined,
  ...props
}: DeleteSourceStreamButtonProps): React.JSX.Element {
  const { t } = useSourceStreamPageTranslation();
  const pageCtx = usePageContext();
  const { onDelete, isDeleting } = useDeleteSourceStream({ streamId, onDeleted });

  return (
    <Control.Button
      data-testid="delete-stream"
      disabled={isDeleting}
      isLoading={isDeleting}
      kind="negative"
      onClick={() => confirmDeleteStreams({ onConfirm: onDelete })}
      size={pageCtx.buttonSize}
      variant="outlined"
      {...props}
    >
      {t('delete')}
    </Control.Button>
  );
}

export const DeleteSourceStreamButtonWithAccess = withPermissions('stream', 'delete')(DeleteSourceStreamButton);
